import { Component, Input, OnChanges } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from '@angular/forms';
import { Obrigatorio } from 'src/app/decorators';

@Component({
  selector: 'app-select-auto-complete',
  templateUrl: './select-auto-complete.component.html',
  styleUrls: ['./select-auto-complete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SelectAutoCompleteComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: SelectAutoCompleteComponent
    }
  ]
})
export class SelectAutoCompleteComponent<T>
  implements OnChanges, ControlValueAccessor, Validator
{
  @Input() inputClass = 'input';
  private _valorInput: T;
  public get valorInput(): T {
    return this._valorInput;
  }
  public set valorInput(v: T) {
    this._valorInput = v;
    this.dadosFiltrados = this.filtrar(v, this.dados, this.exibir);
    this.onChange(v);
  }
  @Input()
  @Obrigatorio()
  dados: T[] = [];
  @Input()
  @Obrigatorio()
  filtrar: (valor: T | string, dados: T[], exibir: this['exibir']) => T[];
  @Input()
  @Obrigatorio()
  exibir: (valor: T) => string;
  @Input()
  @Obrigatorio()
  valor: (valor: T) => T;
  @Input()
  @Obrigatorio()
  funcaoDeComparacao: (valor1: T | string, valor2: T) => boolean;
  dadosFiltrados: T[];
  touched = false;
  disabled = false;
  onChange: (v: T) => void = () => {};
  onTouched = () => {};
  onValidatorChanges = () => {};
  writeValue(obj: any): void {
    this.valorInput = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  tocar() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
  validate(control: AbstractControl): ValidationErrors | null {
    const valor = control.value;
    for (let dado of this.dados) {
      const tipoDado = typeof dado;
      const dadoTipoPrimitivo =
        tipoDado === 'bigint' ||
        tipoDado === 'boolean' ||
        tipoDado === 'number' ||
        tipoDado === 'string';
      if (!dadoTipoPrimitivo && this.funcaoDeComparacao === undefined) {
        throw 'A propriedade "funcaoDeComparacao" é obrigatório quando os items da propriedade "dados" não são de tipo primitivo.';
      }

      if (
        this.funcaoDeComparacao !== undefined &&
        this.funcaoDeComparacao(valor, dado)
      ) {
        return null;
      }

      if (dadoTipoPrimitivo && valor === dado) {
        return null;
      }
    }

    return { invalido: 'Valor deve estar na lista.' };
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChanges = fn;
  }
  ngOnChanges(changes): void {
    this.dadosFiltrados = this.dados;
    if (this.valorInput) {
      this.dadosFiltrados = this.filtrar(
        this.valorInput,
        this.dados,
        this.exibir
      );
    }
    this.onChange(this.valorInput);
  }
}
